import ControllerBase from '../../../../global/js/ControllerBase';

export default class ControllerDateRange extends ControllerBase {

  private checkbox;
  private enabled = false;
  private hiddenInput;
  private value;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
    this.rangeChecker();
  }

  private init() {
    this.hiddenInput = this.$element.querySelector('.js-value');
    const dateInputs = this.$element.querySelectorAll('input[type="date"]');
    this.value = {};
    for (const input of dateInputs) {
      const date = input as HTMLInputElement;
      const key = date.getAttribute('name') || 'start';
      date?.addEventListener('change', () => {
        if (date.value) this.value[key] = date.value;
        else delete this.value[key];
        if (Object.keys(this.value).length) this.hiddenInput.value = this.enabled ? JSON.stringify(this.value) : '';
        else this.hiddenInput.value = '';
      });
      if (date.value) this.value[key] = date.value;
      else delete this.value[key];
      if (Object.keys(this.value).length) this.hiddenInput.value = this.enabled ? JSON.stringify(this.value) : '';
      else this.hiddenInput.value = '';
    }
  }

  private rangeChecker() {
    this.checkbox = this.$element.querySelector('input[type="checkbox"]') as HTMLInputElement;
    const datarangeWrapper = this.$element.querySelector('.date-range-wrapper') as HTMLInputElement;

    this.checkbox?.addEventListener('click', () => {
      if (this.checkbox.checked) {
        this.enabled = true;
        datarangeWrapper?.setAttribute('data-show-dates', 'true')
      } else {
        this.enabled = false;
        datarangeWrapper?.setAttribute('data-show-dates', 'false')
      }
      if (Object.keys(this.value).length) this.hiddenInput.value = this.enabled ? JSON.stringify(this.value) : '';
      else this.hiddenInput.value = '';
    })
  }

}
